export default __webpack_public_path__ + "static/media/Head_3_Ear_2_C3.31fa15a8.svg";